import { render, staticRenderFns } from "./IntegrationSettings.vue?vue&type=template&id=62a0c603&scoped=true"
import script from "./IntegrationSettings.vue?vue&type=script&lang=ts"
export * from "./IntegrationSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a0c603",
  null
  
)

export default component.exports